<template>
	<checker-default-layout :showBreadcrumbs="false">
		<div class="TestPages__Wrapper">
			<div class="TestPages__Title">
				<h1>Test pages</h1>
			</div>
			<h2>Transactional Services</h2>
			<table class="TestPages__Table">
				<tr>
					<th>S.No</th>
					<th>Rule Name</th>
					<th>Pass</th>
					<th>Fail</th>
				</tr>
				<tr v-for="(test, i) in tests" :key="i">
					<td>{{test.sn}}</td>
					<td>{{ test.rule }}</td>
					<td>
						<a
							v-for="link in test.passLinks"
							:key="link"
							:href="getHref(link)"
							target="_blank"
							>{{ link }}<br />
						</a>
						<a :href="
								test.passHref
									? test.passHref
									: getHref(test.passLink)" target="_blank">
							{{ test.passLink }}
						</a>
					</td>
					<td>
						<a
							:href="
								test.failHref
									? test.failHref
									: getHref(test.failLink)
							"
							target="_blank"
							>{{ test.failLink }}</a
						>
					</td>
				</tr>
			</table>
			<div style="margin-top:20px"></div>
			<h2>Informational  Services</h2>
			<table class="TestPages__Table">
				<tr>
					<th>S.No</th>
					<th>Rule Name</th>
					<th>Pass</th>
					<th>Fail</th>
				</tr>
				<tr v-for="(test, i) in tests2" :key="i">
					<td>{{test.sn}}</td>
					<td>{{ test.rule }}</td>
					<td>
						<a
							v-for="link in test.passLinks"
							:key="link"
							:href="getHref(link)"
							target="_blank"
							>{{ link }}<br />
						</a>
						<a :href="
								test.passHref
									? test.passHref
									: getHref(test.passLink)" target="_blank">
							{{ test.passLink }}
						</a>
					</td>
					<td>
						<a
							:href="
								test.failHref
									? test.failHref
									: getHref(test.failLink)
							"
							target="_blank"
							>{{ test.failLink }}</a
						>
					</td>
				</tr>
			</table>
		</div>
	</checker-default-layout>
</template>

<script>
import CheckerDefaultLayout from "../components/page/CheckerDefaultLayout.vue";

export default {
	components: {
		CheckerDefaultLayout,
	},
	data() {
		return {
			tests: [
				{
					sn: "08",
					rule: "Usage of DX+ templates & best practices",
					passLink: "DefaultTemplate",
					failLink: "WithoutTemplate",
					failHref: "/without_template.html",
				},
				{
					sn: "09",
					rule: "Version of CDPL",
					passLink: "valid_cdn",
					passHref: "/valid_cdn.html",
					failLink: "invalid_cdn",
					failHref: "/invalid_cdn.html",
				},
				{
					sn: "10",
					rule: "CSS & JS override",
					passLink: "valid_cdn",
					passHref: "/valid_cdn.html",
					failLink: "with_extra_js_css",
					failHref: "/with_extra_js_css.html"
				},
				{
					sn: "11",
					rule: "Standard page templates",
					passLink: "DefaultTemplate",
					failLink: "NotUsingTemplate",
				},
				{
					sn: "12",
					rule: "Use of sorry/error page",
					passLinks: ["DefaultTemplate","SorryPage"],
					failLink: "DefaultTemplate",
				},
				{
					sn: "15",
					rule: "Use of Summary Page",
					passLinks: ["SingleStepForm", "SummaryPage"],
					failLink: "SingleStepForm",
				},
				{
					sn: "16",
					rule: "Page title",
					passLink: "DefaultTemplate",
					failLink: "WithoutTitle",
					failHref: "/without_title.html",
				},
				{
					sn: "17",
					rule: "Usage of images as navigation",
					passLink: "DefaultTemplate",
					failLink: "WithImageNavigation",
				},
				{
					sn: "18",
					rule: "Usage of images best practices(alt text)",
					passLink: "WithInfoServiceImageNavigation",
					failLink: "WithInfoServiceImageNavigationFail",
				},
				{
					sn: "19",
					rule: "Usage of breadcrumbs",
					passLink: "DefaultTemplate",
					failLink: "WithoutBreadcrumb",
				},
				{
					sn: "20",
					rule: "Usage of iframes",
					passLink: "DefaultTemplate",
					failLink: "UsingIframe",
				},
				{
					sn: "22",
					rule: "Standard Header",
					passLink: "DefaultTemplate",
					failLink: "WithoutHeader",
				},
				{
					sn: "23",
					rule: "Standard Footer",
					passLink: "DefaultTemplate",
					failLink: "WithoutFooter",
				},
				{
					sn: "24",
					rule: "Progress Indicator",
					passLink: "MultiStepForm",
					failLink: "MultiStepFormNoIndicator",
				},
				{
					sn: "25",
					rule: "Save as Draft",
					passLink: "SingleStepForm",
					failLink: "WithoutSaveButton",
				},
				{
					sn: "26",
					rule: "Profile",
					passLink: "DefaultTemplate",
					failLink: "WithoutProfile",
				},
				{
					sn: "27",
					rule: "Form sections",
					passLink: "SingleStepForm",
					failLink: "FormWithNoSections",
				},
				{
					sn: "28",
					rule: "Number of form sections",
					passLink: "SingleStepForm",
					failLink: "SingleStep6Sections",
				},
				{
					sn: "31",
					rule: "Use of Acknowledgement page",
					passLinks: ["SingleStepForm", "AcknowledgementPage"],
					failLink: "SingleStepForm",
				},
				{
					sn: "32",
					rule: "Use of fields in acknowledgement page",
					passLink: "AcknowledgementPage",
					failLink: "AcknowledgementPageNoFields",
				},
				{
					sn: "33",
					rule: "Step Indicator",
					passLink: "MultiStepForm",
					failLink: "MultiStepForm7Steps",
				},
				{
					sn: "35",
					rule: "File size in links",
				}
			],
			tests2: [
				{
					sn: "05",
					rule: "Usage of DX+ templates & best practices",
					passLink: "DefaultInfoServiceTemplate",
					failLink: "WithoutTemplate",
					failHref: "/without_template.html",
				},
				{
					sn: "06",
					rule: "Version of CDPL",
					passLink: "valid_cdn_is",
					passHref: "/valid_cdn_is.html",
					failLink: "invalid_cdn",
					failHref: "/invalid_cdn.html",
				},
				{
					sn: "07",
					rule: "CSS & JS override",
					passLink: "valid_cdn_is",
					passHref: "/valid_cdn_is.html",
					failLink: "with_extra_js_css",
					failHref: "/with_extra_js_css.html"
				},
				{
					sn: "08",
					rule: "Standard page templates",
					passLink: "DefaultInfoServiceTemplate",
					failLink: "NotUsingTemplate",
				},
				{
					sn: "09",
					rule: "Use of sorry/error page",
					passLinks: ["DefaultInfoServiceTemplate","SorryPage"],
					failLink: "DefaultInfoServiceTemplate",
				},
				{
					sn: "11",
					rule: "Page title",
					passLink: "DefaultInfoServiceTemplate",
					failLink: "WithoutTitle",
					failHref: "/without_title.html",
				},
				{
					sn: "12",
					rule: "Usage of images as navigation",
					passLink: "DefaultInfoServiceTemplate",
					failLink: "WithImageNavigation",
				},
				{
					sn: "13",
					rule: "Usage of images best practices(alt)",
					passLink: "ImageWithAltInfo",
					failLink: "ImageWithoutAltInfo",
				},
				{
					sn: "14",
					rule: "Usage of images best practices (format)",
					passLink: "ImageWithAltInfo",
					failLink: "ImageWrongFormatInfo",
				},
				{
					sn: "15",
					rule: "Usage of breadcrumbs",
					passLink: "DefaultInfoServiceTemplate",
					failLink: "WithoutBreadcrumb",
				},
				{
					sn: "16",
					rule: "Usage of iframes",
					passLink: "DefaultInfoServiceTemplate",
					failLink: "UsingIframe",
				},
				{
					sn: "18",
					rule: "Standard Header",
					passLink: "DefaultInfoServiceTemplate",
					failLink: "WithoutHeader",
				},
				{
					sn: "19",
					rule: "Standard Footer",
					passLink: "DefaultInfoServiceTemplate",
					failLink: "WithoutFooter",
				},
				{
					sn: "21",
					rule: "File size in links"
				},
				{
					sn: "23",
					rule: "Show list of eservices and useful information",
					passLink: "ListOfeServices",
					failLink: "ListOfeServicesWithNoServices"
				},
				{
					sn: "24",
					rule: "Usage of Service landing page for an eservice",
					passLink: "ServiceLandingPage"
				},
				{
					sn: "25",
					rule: "Use of Global navigation menu",
					passLink: "GlobalMenuPage",
					failLink: "DefaultInfoServiceNoGlobalNav"
				},
				{
					sn: "26",
					rule: "Use of Announcements, News etc in home page",
					passLink: "LandingPage",
					failLink: "LandingPageWithoutArticles"
				},
				{
					sn: "28",
					rule: "Last updated date stamp",
					passLink: "LandingPage",
					failLink: "LandingPageWithoutTimeStamp"
				},
				{
					sn: "29",
					rule: "Use of global footer bar",
					passLink: "LandingPage",
					failLink: "LandingPageWithoutFooter"
				},
				{
					sn: "30",
					rule: "Use of sitemap template",
					passLinks: ["LandingPage","SiteMapPage"],
					failLink: "LandingPage"

				},
				{
					sn: "31",
					rule: "Use of CORRECT naming Title Metadeta and Meta Description"
				},
				{
					sn: "33",
					rule: "Usage of Links (Visited vs Unvisited) + Best Practices",
					passLink: "LandingPage",
					failLink: "Non MomLink",
					failHref: "/without_meta.html",
				},
			],
		};
	},
	methods: {
		getHref(link) {
			return this.$router.resolve({ name: link }).href;
		},
	},
};
</script>

<style lang="scss" scoped>
.TestPages__Wrapper {
	display: flex;
	flex-direction: column;
}

.TestPages__Title {
	@include font-size(xl);
	@include font-weight(semibold);
	width: 100%;
	text-align: center;
	margin-bottom: rem(20);
}

table,
tr,
th,
td {
	border: 1px solid #000;
}

th {
	background: rgba(0, 0, 0, 0.05);
	@include font-weight(semibold);
	text-align: left;
}

th,
td {
	padding: rem(10) rem(8);
}

th:first-child {
    width: 50px;
}
th:nth-child(2){
	width: 450px;
}
h2 {
  background: rgba(0, 0, 0, 0.15);
  font-weight: 600 !important;
  text-align: left;
}
</style>
